import axios from 'axios'
import { SALES_ENDPOINT } from '../../endpoints'

export async function updateSale(id, body) {
  try {
    const response = await axios.put(`${SALES_ENDPOINT}/${id}`, body)
    return response.data?.data
  } catch (e) {
    if (e.response && e.response.data?.message) throw new Error(e.response.data?.message)
    throw e
  }
}
